<div class="flex items-center justify-center min-h-screen px-4 bg-gray-50">

    <div class="relative w-full max-w-md p-8 bg-white shadow-lg rounded-xl animate-fade-in">

        <div class="mb-8 text-center">
            <p class="mb-1 text-xs text-gray-500">Selamat datang kembali 👋</p>
            <h1 class="text-xl font-bold text-primary font-heading">Masuk Akun {{ roleDisplayName }}</h1>
            <p *ngIf="!isCodeSent" class="mt-1 text-xs text-gray-500">
                Gunakan Username {{ roleDisplayName }} Anda untuk melanjutkan
            </p>
            <p *ngIf="isCodeSent" class="mt-1 text-xs text-gray-500">
                Masukkan kode verifikasi yang Anda terima
            </p>
        </div>

        <form *ngIf="!isCodeSent" (ngSubmit)="sendCode()" class="space-y-6">

            <div>
                <label class="text-sm font-semibold text-gray-700">Username</label>
                <input type="text" [(ngModel)]="username" name="username" [placeholder]="'Masukkan Username ' + roleDisplayName"
                    class="w-full mt-2 border rounded-lg px-4 py-3 bg-gray-50 text-gray-800 focus:ring-2 focus:ring-primary focus:outline-none" />
            </div>

            <button type="submit" [disabled]="loading"
                class="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary-dark transition active:scale-95 disabled:opacity-40 shadow-xs">
                <span *ngIf="!loading">Kirim Kode Verifikasi</span>

                <span *ngIf="loading" class="flex items-center justify-center gap-2">
                    <span class="w-5 h-5 border-2 border-white rounded-full border-t-transparent animate-spin"></span>
                    Mengirim...
                </span>
            </button>

        </form>

        <div *ngIf="isCodeSent" class="space-y-6">

            <div class="text-center">
                <p class="text-sm text-gray-600">
                    Kode verifikasi telah dikirim ke WhatsApp terdaftar Anda
                </p>
            </div>

            <div class="space-y-4">

                <div class="flex justify-center gap-3 mb-6">
                    <input #otpInput *ngFor="let d of otpDigits; let i = index; trackBy: trackByIndex" [id]="'otp-' + i"
                        type="tel" inputmode="numeric" pattern="[0-9]*" enterkeyhint="next" autocomplete="one-time-code"
                        maxlength="1" [disabled]="otpExpired"
                        class="w-10 h-12 text-lg font-semibold text-center transition duration-150 border-2 outline-none sm:w-12 sm:h-14 sm:text-xl rounded-xl focus:ring-0"
                        [ngClass]="{
                            'border-red-500 animate-shake': otpError && !otpExpired,
                            'border-gray-400 bg-gray-100 cursor-not-allowed': otpExpired,
                            'border-primary': !otpError && !otpExpired && otpDigits[i],
                            'border-gray-300': !otpError && !otpExpired && !otpDigits[i]
                            }" [value]="otpDigits[i]" (input)="onOtpInput($event, i)"
                        (keydown)="onOtpKeyDown($event, i)" (paste)="onOtpPaste($event)" />
                </div>

                <p *ngIf="otpError && !otpExpired" class="text-xs text-center text-red-500">
                    {{ otpError }}
                </p>

                <p *ngIf="otpExpired" class="text-xs font-semibold text-center text-red-600">
                    Kode OTP sudah kadaluarsa. Silakan kirim ulang
                </p>

                <div class="text-center">
                    <p *ngIf="otpCountdown > 0" class="text-xs text-gray-500">
                        Masukkan kode sebelum
                        <span class="font-semibold text-primary">
                            {{ otpTimerDisplay }}
                        </span>
                    </p>

                    <button *ngIf="otpCountdown <= 0" type="button" (click)="resendOtp()" [disabled]="loading"
                        class="text-sm font-semibold text-primary disabled:opacity-50 disabled:cursor-not-allowed hover:underline">
                        <span *ngIf="!loading">Kirim Ulang OTP</span>
                        <span *ngIf="loading" class="inline-flex items-center gap-1.5 text-gray-500">
                            <span
                                class="w-3.5 h-3.5 border-2 border-primary rounded-full border-t-transparent animate-spin"></span>
                            Mengirim ulang...
                        </span>
                    </button>
                </div>

            </div>

            <button type="button" (click)="cancelOtp()" class="w-full text-sm text-gray-500 hover:underline">
                Kembali
            </button>
        </div>

        <div *ngIf="verifying"
            class="absolute inset-0 z-50 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl">
            <div class="flex flex-col items-center gap-3">
                <span class="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></span>
                <p class="text-sm font-semibold text-gray-700">
                    Memverifikasi kode...
                </p>
            </div>
        </div>
    </div>
</div>